/* eslint-disable import/no-cycle */
import React from 'react';
import Stack from '@mui/material/Stack';
import { WrappedFunctionProps } from '../types';
import { hasRenderedChildren } from '../helper';

export default function Row({ children }: WrappedFunctionProps) {
  if (!hasRenderedChildren(children)) return null;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={1}
      sx={{ ' > *': { width: '100%' } }}
    >
      {children}
    </Stack>
  );
}
